module.exports = __webpack_public_path__ + "img/buttonicon4.d83b5c7a.png";